import {
  handleCreateOrganization,
  handleEditOrganization,
} from 'serviceWorker/services/organizations';
import { getLogoSignedUrl } from 'serviceWorker/services/organizations/logoSignedUrl';
import { organizationSource } from 'serviceWorker/services/organizations/organizationSource';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { organizationContract } from 'shared/domain/organization/organizationContract';
import { serveEntityRequests } from './serveEntityRequests';

/**
 * Answers the organization requests. A change is answered once queued; its
 * outcome follows as an event with the change's `uniqueId`; a logo's signed
 * URL once the server signed it.
 */
export function serveOrganizationRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(organizationContract, organizationSource),
    channelServer.handle(organizationContract, {
      create: handleCreateOrganization,
      edit: handleEditOrganization,
      getLogoSignedUrl,
    }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
